var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 253.1 360.7",
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 2.2499847412109375, 0, 0, 2.2499847412109375, 282.95,200.25) "
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-13.3-58.7c0-1.7-0.6-3.1-1.8-4.4c-1.3-1.3-2.7-1.9-4.4-1.9h-43.7v-17.8c0-1.7-0.6-3.1-1.9-4.3                                 c-1.3-1.3-2.7-1.9-4.4-1.9c-1.7,0-3.1,0.6-4.3,1.9c-1.3,1.2-1.9,2.7-1.9,4.3V-65h-43.7c-1.7,0-3.1,0.6-4.3,1.9                                 c-1.3,1.2-1.9,2.7-1.9,4.4v100c0,1.7,0.6,3.1,1.9,4.4c1.2,1.2,2.7,1.9,4.3,1.9h43.7V65c0,1.7,0.6,3.1,1.9,4.4                                 c1.2,1.2,2.7,1.8,4.3,1.8c1.7,0,3.1-0.6,4.4-1.8c1.2-1.3,1.9-2.7,1.9-4.4V47.5h43.7c1.7,0,3.1-0.6,4.4-1.9                                 c1.2-1.3,1.8-2.7,1.8-4.4V-58.7 M-69.5-52.5V35h-43.7v-87.5H-69.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareIcon);
export default __webpack_public_path__ + "static/media/compare_icon.e80223c2.svg";
export { ForwardRef as ReactComponent };